import * as React from 'react'
import Box from '@mui/material/Box'
import useStyles from './styles'
import clsx from 'clsx'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store/store'
import { GetLayoutRes } from 'src/types/store'
import ReactMarkdown from 'react-markdown'
import rehypeSlug from 'rehype-slug'
import rehypeRaw from 'rehype-raw'
import { useEffect, useMemo } from 'react';

interface IProps {
  content: GetLayoutRes
}

const GetConfidentialSupportComponent: React.FC<IProps> = ({ content }) => {
  const { classes } = useStyles()
  const zenMode = useSelector((state: RootState) => state.zenModeState.zenMode)
  const [userToken, setUserToken] = React.useState<string | null>(null)

  useEffect(() => {
    setUserToken(
      typeof window === 'object' ? localStorage.getItem('dtl_token') : null
    )
  }, [])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const rehypeRawDec: any = useMemo(() => rehypeRaw, []);

  const text = useMemo(() => {
    if (userToken) {
      return content.data.attributes.HeaderTopTextForSignup
    } else {
      return content.data.attributes.HeaderTopTextForNonSignup
    }
  }, [content.data.attributes.HeaderTopTextForNonSignup, content.data.attributes.HeaderTopTextForSignup, userToken])


  return (
    <Box
      component="div"
      className={clsx(classes.root, zenMode && classes.zenMode)}
    >
      <ReactMarkdown rehypePlugins={[rehypeRawDec, rehypeSlug]}>{text}</ReactMarkdown>
    </Box>
  )
}

export default GetConfidentialSupportComponent
